import { Component } from 'preact'

import { editContent } from '../services/topicService'
import { ContentType } from '@insided/shared/utils/contentType'
import { Reply } from '../interfaces'
import { PageUnloadContext } from '@insided/shared/services/PageUnloadContext'
import ReplyInContent from './ReplyInContent'

/* eslint-disable import/no-internal-modules */
import Content from '@insided/deprecated-preact-components/common/Content'
import Editor from '@insided/deprecated-preact-components/editor'

export interface OpeningPostContentProps {
  topicId: number
  contentType: ContentType
  content: string | null
  pinnedReply?: Reply | null
  bestAnswer: Reply | null
  showEditor: boolean
  onChangeContent: (content: string) => void
  onCancel: () => void
  onShowAlert: (type: 'success' | 'error', message?: string) => void
}

export interface PostContentState {
  content: string | null
  isLoading: boolean
}

class OpeningPostContent extends Component<OpeningPostContentProps, PostContentState> {
  constructor (props: OpeningPostContentProps) {
    super(props)
    this.state = {
      content: props.content,
      isLoading: false
    }
    this.onChange = this.onChange.bind(this)
    this.onSaveChanges = this.onSaveChanges.bind(this)
    this.onCancel = this.onCancel.bind(this)
  }

  onChange (content: string) {
    this.setState({ content })
  }

  async onSaveChanges () {
    const { contentType, topicId, onChangeContent, onCancel, onShowAlert } = this.props
    const { content } = this.state
    this.setState({ isLoading: true })
    try {
      await editContent(contentType, topicId, String(content))
      onChangeContent(String(content))
      onCancel()
    } catch {
      onShowAlert('error')
    }
    this.setState({ isLoading: false })
  }

  onCancel () {
    const { content, onCancel } = this.props
    this.setState({ content })
    onCancel()
  }

  render () {
    const { showEditor, pinnedReply, bestAnswer, content: data } = this.props
    const { content, isLoading } = this.state

    if (showEditor) {
      return (
        <div className='post--content post--content-new-editor'>
          <PageUnloadContext.Consumer>
            {({ lock, unlock }) => {
              return (
                <Editor
                  isControl
                  data={content}
                  isLoading={isLoading}
                  attachments={[]}
                  canHavePoll={false}
                  onChange={(content: string) => {
                    this.onChange(content)
                    lock(content, data)
                  }}
                  onSubmit={async () => {
                    unlock()
                    await this.onSaveChanges()
                  }}
                  onCancel={() => {
                    unlock()
                    this.onCancel()
                  }}
                  profile='openingPost'
                />
              )
            }}
          </PageUnloadContext.Consumer>
        </div>
      )
    }

    return (
      <div className='post--content post--content-new-editor'>
        <Content content={content ?? ''} className='qa-post-content' isControl />
        {pinnedReply &&
          <ReplyInContent
            id={pinnedReply.id}
            publicReplyId={pinnedReply.publicReplyId}
            title='Pinned reply'
            author={pinnedReply.author}
            content={pinnedReply.content}
            repliedAt={pinnedReply.repliedAt}
          />}
        {bestAnswer &&
          <ReplyInContent
            id={bestAnswer.id}
            publicReplyId={bestAnswer.publicReplyId}
            title='Best answer'
            author={bestAnswer.author}
            content={bestAnswer.content}
            repliedAt={bestAnswer.repliedAt}
          />}
      </div>
    )
  }
}

export default OpeningPostContent
